import { render, staticRenderFns } from "./PayBasisInfo.vue?vue&type=template&id=463fefc6&scoped=true"
import script from "./PayBasisInfo.vue?vue&type=script&lang=js"
export * from "./PayBasisInfo.vue?vue&type=script&lang=js"
import style0 from "./PayBasisInfo.vue?vue&type=style&index=0&id=463fefc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463fefc6",
  null
  
)

export default component.exports